import React from 'react';
import { color } from '@strava/ui-tokens/js';
import clsx from '../clsx';

export interface StravaLogoProps {
  alt?: string;
  className?: string;
  width: string | number;
  height: string | number;
  fill: string;
  style: React.CSSProperties;
}

function StravaLogo({
  className,
  alt = 'Strava',
  width = 'auto',
  height = 'auto',
  fill = color.colorCoreO3,
  style,
  ...props
}: StravaLogoProps) {
  return (
    <svg
      role="img"
      viewBox="0 0 485 95"
      aria-labelledby="stravalogo"
      className={clsx(className)}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', width, height, ...style }}
      {...props}
    >
      <title id="stravalogo">{alt}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M258.505 90.4524L258.502 90.4484H284.108L299.838 58.8214L315.567 90.4484H346.682L299.835 -0.000610352L255.366 85.8686L238.292 60.9384C248.834 55.8544 255.405 47.0494 255.405 34.4014V34.1524C255.405 25.2254 252.678 18.7764 247.469 13.5674C241.392 7.49139 231.596 3.64739 216.22 3.64739H173.809V90.4524H202.827V65.6504H209.027L225.396 90.4524H258.505ZM437.447 -0.000610352L390.606 90.4484H421.721L437.45 58.8214L453.18 90.4484H484.294L437.447 -0.000610352ZM368.669 94.0074L415.51 3.55839H384.396L368.666 35.1854L352.936 3.55839H321.822L368.669 94.0074ZM215.352 44.9414C222.295 44.9414 226.512 41.8414 226.512 36.5094V36.2604C226.512 30.6804 222.171 27.9524 215.476 27.9524H202.827V44.9414H215.352ZM111.753 28.2004H86.2089V3.64739H166.316V28.2004H140.772V90.4524H111.753V28.2004ZM15.5019 58.9544L-9.15527e-05 77.4314C11.0369 87.1054 26.9099 92.0644 44.5179 92.0644C67.8319 92.0644 82.8369 80.9034 82.8369 62.6734V62.4264C82.8369 44.9414 67.9559 38.4924 45.7589 34.4014C36.5819 32.6634 34.2259 31.1774 34.2259 28.8204V28.5724C34.2259 26.4644 36.2109 24.9764 40.5499 24.9764C48.6099 24.9764 58.4079 27.5804 66.5909 33.5324L80.7289 13.9404C70.6839 6.00339 58.2839 2.03439 41.5429 2.03439C17.6079 2.03439 4.71191 14.8084 4.71191 31.3004V31.5494C4.71191 49.9014 21.8259 55.4834 41.2939 59.4494C50.5949 61.3104 53.3219 62.6734 53.3219 65.1544V65.4034C53.3219 67.7584 51.0909 69.1214 45.8819 69.1214C35.7139 69.1214 24.9259 66.1474 15.5019 58.9544Z"
        fill={fill}
      />
    </svg>
  );
}

export default StravaLogo;
